import React, { useState } from "react";
import { Form, Input, Button as AntdButton, Card as AntdCard, Typography } from "antd";
import { Mail, Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector  } from "react-redux";
import { toast } from "react-toastify";
// import { loginSuccess } from "../store/slices/authSlice";
import { login } from "../store/slices/authSlice";

const { Title, Paragraph } = Typography;

const Login = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);

  const onFinish = async (values) => {
    try {
      const trimmedValues = {
        email: (values.email || "").trim(),
        password: (values.password || "").trim()
      };
      // console.log("Login values:", trimmedValues);
      const result = await dispatch(
        login({
          email: trimmedValues.email,
          password: trimmedValues.password,
        })
      ).unwrap();
      // console.log("Login result:", result);
      toast.success("Successfully logged in!");
      navigate("/dashboard", { replace: true });
    } catch (err) {
      toast.error(
        err.message || "Login failed. Please check your credentials."
      );
    }
  };

  const handleCreateAccount = () => {
    navigate("/signup");
  };

  return (
    <div className="min-h-[100dvh]  flex items-center justify-center p-4">
      <AntdCard className="w-full max-w-md bg-[#141c31] shadow-2xl border-0 rounded-2xl overflow-hidden">
        <div className="p-6">
          <div className="text-center mb-6">
            <Title
              level={2}
              className="!m-0 !text-4xl !font-semibold !text-white"
            >
              Welcome Back
            </Title>
            <Paragraph className="mt-3 !text-white text-base">
              Please sign in to your account
            </Paragraph>
          </div>

          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            className="space-y-6"
            initialValues={{ email: "", password: "" }}
          >
            {/* Email */}
            <Form.Item
              label={<span className="text-gray-200 text-base">Email</span>}
              name="email"
              rules={[
                { required: true, message: "Please enter your email" },
              ]}
            >
              <Input
                prefix={<Mail className="w-5 h-5 text-gray-500" />}
                type="email"
                placeholder="Enter your email"
                size="large"
                className="h-12 bg-gray-50 border-gray-200 rounded-lg"
                disabled={loading}
              />
            </Form.Item>

            {/* Password */}
            <Form.Item
              label={<span className="text-gray-200 text-base">Password</span>}
              name="password"
              rules={[
                { required: true, message: "Please enter your password" },
              ]}
            >
              <Input.Password
                prefix={<Lock className="w-5 h-5 text-gray-500" />}
                placeholder="Enter your password"
                size="large"
                className="h-12 bg-gray-50 border-gray-200 rounded-lg"
                disabled={loading}
              />
            </Form.Item>

            {error && <div className="text-red-500 text-sm mb-4">{error}</div>}

            {/* Forgot Password */}
            <div className="text-right">
              <button
                type="button"
                className="font-semibold text-blue-500 hover:text-blue-400 transition-colors text-base"
                onClick={() => navigate("/forgot-password")}
                disabled={loading}
              >
                Forgot Password?
              </button>
            </div>

            {/* Submit */}
            <Form.Item>
              <AntdButton
                htmlType="submit"
                type="primary"
                size="large"
                loading={loading}
                className="w-full h-12 bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white font-medium rounded-lg shadow-lg hover:shadow-xl transition-all duration-200"
              >
                {loading ? "Signing In..." : "SIGN IN"}
              </AntdButton>
            </Form.Item>
          </Form>

          {/* Divider */}
          <div className="my-6 flex items-center">
            <div className="flex-1 border-t border-gray-200" />
            <div className="px-4 text-gray-200">or</div>
            <div className="flex-1 border-t border-gray-200" />
          </div>

          {/* Create Account */}
          <div className="flex items-center justify-center">
            <p className="text-white text-base">Don't have an account?</p>
            <AntdButton
              type="button"
              className="font-semibold text-blue-500 hover:text-blue-400 transition-colors text-base"
              onClick={handleCreateAccount}
              disabled={loading}
            >
              Sign Up
            </AntdButton>
          </div>
        </div>
      </AntdCard>
    </div>
  );
}
export default Login;
